const MAIN_PAGE_TYPE_LEFT = 'left_right';
const MAIN_PAGE_TYPE_TOP_LEFT = 'top_left_right';
const MAIN_PAGE_TYPE_TOP = 'top_bottom';
const MAIN_PAGE_TYPE_LEFT_RIGHT_TOP = 'left_right_top';

const THEMES = [
  {label: '默认', value: 'theme-chalk'},
  {label: '绿野仙踪', value: '25CB6F'},
  {label: '神秘紫韵', value: 'A81AD3'},
  {label: '红色激情', value: 'FF0000'}
];

const ENERGY_FILE_SERVER = 'http://10.0.2.191:8032';

/** start*** 尺寸类常量 */
const INPUT_SIZE = 8;
const PAGE_SIZE_8 = 8;
const PAGE_SIZE_10 = 10;
const PAGE_SIZE_12 = 12;
const PAGE_SIZE_18 = 18;
/** end*** 尺寸类常量 */

/** start*** 数据类型常量 */
const PROTOCOL_MAP = {
  0: '无效(33)',
  1: '电表1997(1)',
  2: '交流采样装置(2)',
  30: '电表2007(30)',
  31: '载波通信模块(31)',
  12: '威盛4.1(12)',
  20: '浙江规约(20)',
  33: '多功能电表(33)',
  35: 'JCY(35)'
};
const SPEED_MAP = {
  0: '默认',
  1: 600,
  2: 1200,
  3: 2400,
  4: 4800,
  5: 7200,
  6: 9600,
  7: 19200
};
const PROVINCE_ABBREVIATION = [
  {code: 0, name: "全部", sub_name: "全部"},
  {code: 1, name: "北京", sub_name: "京"},
  {code: 2, name: "天津", sub_name: "津"},
  {code: 3, name: "河北", sub_name: "冀"},
  {code: 4, name: "山西", sub_name: "晋"},
  {code: 5, name: "内蒙古", sub_name: "蒙"},
  {code: 6, name: "辽宁", sub_name: "辽"},
  {code: 7, name: "吉林", sub_name: "吉"},
  {code: 17, name: "湖北", sub_name: "鄂"}
];

const ELECTRIC_TYPE = ['', '遥信', '遥测', '累积量'];
const DUTY_TYPE = ['', '', '', '外勤', '出差', '未带卡', '班车晚点', '手工考勤', '病假', '事假', '调休', '年假', '考休假',
  '工伤假', '婚假', '丧假', '产护假', '探亲假', '其他假'];
/** end*** 数据类型常量 */

/** start*** 配置系统识别号 */
const PERMISSION_ID = '0'; // 权限管理
const SMART_CARD_ID = '1'; // 一卡通系统
const ENERGY_EFFICIENCY_ID = '2'; // 能效系统
const ENTRANCE_ID = '3'; // 疫情系统
const EPIDEMIC_ID = '4'; // 出入口系统
const SECURITY_ID = '5'; // 智慧安防系统
const ASSETS_ID = '6'; // 资产管理系统
const MODELS_ID = '7';
/** end*** 配置系统标题 */

/** start*** 配置系统标题 */
const PERMISSION_TITLE = '权限管理平台'; // 权限管理标题
const SMART_CARD_TITLE = '一卡通管理平台'; // 一卡通系统标题
const ENERGY_EFFICIENCY_TITLE = 'KN-2000E'; // 能效系统标题
const EPIDEMIC_TITLE = '疫情防控平台'; // 疫情系统标题
const EPIDEMIC_SCREEN_TITLE = '疫情防控大屏'; // 疫情系统标题
const ENTRANCE_TITLE = '出入口管理系统'; // 出入口系统标题
const SECURITY_TITLE = '智慧安防系统'; // 智慧安防系统标题
const ASSETS_TITLE = '资产管理系统'; // 资产管理系统标题
const MODELS_TITLE = '3d模型测试';
/** end*** 配置系统标题 */

/** start*** 配置系统图标 */
const PERMISSION_ICON = 'zy-icon-permission'; // 权限管理系统图标
const SMART_CARD_ICON = 'zy-icon-synthesis'; // 一卡通系统图标
const ENERGY_EFFICIENCY_ICON = require('../assets/images/company_white.png'); // 能效系统图标
const ENERGY_EFFICIENCY_ICON1 = require('../assets/images/company_white1.png'); // 能效系统图标
const ENTRANCE_ICON = 'zy-icon-entrance'; // 出入口系统图标
/** end*** 配置系统图标 */

/** start*** 配置系统模块图标 */
const PERMISSION_MENU_ICONS = {
  '101': 'zy-icon-grouping',
  '102': 'zy-icon-setting-gear'
};
const SMART_CARD_MENU_ICONS = {
  '01': 'zy-icon-manage-center zy-icon',
  '02': 'zy-icon-access zy-icon',
  '03': 'zy-icon-elevator zy-icon',
  '04': 'zy-icon-register-total zy-icon',
  '05': 'zy-icon-register-total zy-icon',
  '06': 'zy-icon-consume-manage zy-icon',
  '07': 'zy-icon-consume-manage zy-icon'
};
const ENERGY_EFFICIENCY_MENU_ICONS = {
  '00': 'zy-icon-energy-screen',
  '01': 'zy-icon-energy-monitor',
  '02': 'zy-icon-energy-sum',
  '03': 'zy-icon-energy-analyse',
  '04': 'zy-icon-energy',
  '05': 'zy-icon-warn-manage',
  '06': 'zy-icon-energy-brief',
  '07': 'zy-icon-report-manage',
  '08': 'zy-icon-pdf',
  '09': 'zy-icon-sys-setting',
  '10': 'zy-icon-param-setting',
  '11': 'zy-icon-operation-manage',
  '12': 'zy-icon-file-manage',
  '13': 'zy-icon-param-setting',
  '14': 'zy-icon-sys-setting',
  '16': 'zy-icon-system-setting',
  '21': 'zy-icon-building',
  '33': 'zy-icon-door-close',
  '34': 'zy-icon-manual-register'
};
const ENTRANCE_MENU_ICONS = {
  '001': 'zy-icon-entrance',
  '002': 'zy-icon-entrance-car',
  '003': 'zy-icon-car-manage'
};
const EPIDEMIC_MENU_ICONS = {
  '001': 'zy-icon-epidemic-staff',
  '002': 'zy-icon-grouping',
  '0030': 'zy-icon-epidemic-temperature',
  '0040': 'zy-icon-epidemic-source',
  '005': 'zy-icon-epidemic-monitor'
};
const SECURITY_MENU_ICONS = {
  '001': 'zy-icon-security-monitor',
  '002': 'zy-icon-play',
  '003': 'zy-icon-info-notice',
  '004': 'zy-icon-loc',
  '005': 'zy-icon-grouping',
  '006': 'zy-icon-attendance-info',
  '007': 'zy-icon-user-info'
};
const ASSETS_MENU_ICONS = {
  '001': 'zy-icon-system-setting',
  '002': 'zy-icon-down-block',
  '008': 'zy-icon-screening',
  '014': 'zy-icon-setting-gear',
  '020': 'zy-icon-grouping',
  '022': 'zy-icon-grouping'
};
const MODELS_MENU_ICONS = {
  '001': 'zy-icon-system-setting'
};
/** end*** 配置系统模块图标 */

// 默认权限菜单属性
const STATIC_PERMISSION_PROP = ['id', 'name', 'parentId', 'childNode'];

const GREEN_MENU_COLORS = {
  textColor: '#fff',
  activeTextColor: '#000',
  backgroundColor: '#08b783'
};
const BLACK_MENU_COLORS = {
  textColor: '#9da4b3',
  activeTextColor: '#fff',
  backgroundColor: '#0e0e0e'
};
const WHITE_MENU_COLORS = {
  textColor: '#000',
  activeTextColor: '#9da4b3',
  backgroundColor: '#fff'
};

const TEST_LOGIN_DATA = {
  companyId: "001",
  isadmin: 0,
  isTest: true,
  id: "001",
  isCompany: 1,
  permission: [
    {SYS_ID: SMART_CARD_ID, SYS_NAME: SMART_CARD_TITLE, USER_ID: "001", IS_COMPANY: 1, COMPANY_ID: "001"},
    {SYS_ID: ENERGY_EFFICIENCY_ID, SYS_NAME: ENERGY_EFFICIENCY_TITLE, USER_ID: "001", IS_COMPANY: 1, COMPANY_ID: "001"}
  ],
  userInfo: {
    username: 'test'
  }
};

const TEST_SYS_MODULES = {
  '智慧安防系统': {
    premission: [
      {
        id: "01", name: "体温相关测试", parentId: "root", childNode: [
          { id: "0101", name: "ftp测试", parentId: "01", childNode: [] }
        ]
      },
      {
        id: "02", name: "地图相关测试", parentId: "root", childNode: [
          { id: "0201", name: "百度地图测试", parentId: "02", childNode: [] }
        ]
      }
    ]
  },
  // '疫情管理系统': {
  //   premission: [
  //     {id: "001", name: "体温筛查", parentId: "root", childNode: []},
  //     {id: "003", name: "地图", parentId: "root", childNode: []},
  //     {id: "002", name: "疫情大屏", parentId: "root", childNode: []}
  //   ]
  // },
  '疫情管理系统': {
    premission: [
      {
        id: "001", name: "人员管理", parentId: "root", childNode: [
          { id: "00101", permCode: '00101', name: "员工管理", parentId: "001", childNode: [] },
          { id: "00102", permCode: '00102', name: "访客管理", parentId: "001", childNode: [] },
          { id: "00103", permCode: '00103', name: "上班人数统计", parentId: "001", childNode: [] }
        ]
      },
      {
        id: "002", name: "设备管理", parentId: "root", childNode: [
          { id: "00201", permCode: '00101', name: "员工管理", parentId: "001", childNode: [] },
          { id: "00202", permCode: '00102', name: "访客管理", parentId: "001", childNode: [] }
        ]
      },
      {id: "003", name: "测温管理", parentId: "root", childNode: []},
      {id: "004", name: "防疫政策管理", parentId: "root", childNode: []},
      {
        id: "005", name: "疫情监控", permCode: "005", parentId: "root", childNode: [
          {name: "疫情数据统计", id: "00501", permCode: "00501", parentId: "005", childNode: []},
          {name: "出入口监控", id: "00502", permCode: "00502", parentId: "005", childNode: []}
        ]
      }
    ]
  },
  '出入口管理系统': {
    premission: [
      {id: "001", name: "人员出入记录", parentId: "root", childNode: []},
      {id: "002", name: "车辆出入记录", parentId: "root", childNode: []},
      {id: "003", name: "车辆/车主信息", parentId: "root", childNode: []}
    ]
  },
  '一卡通系统': {
    premission: [
      {
        id: "001", permCode: '01', name: "系统管理", parentId: "root", childNode: [
          { id: "0101", permCode: '0101', name: "员工管理", parentId: "01", childNode: [] },
          { id: "0102", permCode: '0102', name: "角色管理", parentId: "01", childNode: [] },
          { id: "0103", permCode: '0103', name: "建筑管理", parentId: "01", childNode: [] }
        ]
      }
    ]
  },
  '能效管理系统': {
    premission: [
      {
        id: "00", name: "大屏展示", parentId: "root", childNode: []
      },
      {
        id: "01", name: "能效总览", parentId: "root", childNode: [
          { id: "011", name: "主系统图", parentId: "01", childNode: [] },
          { id: "012", name: "数据概览", parentId: "01", childNode: [] },
          { id: "013", name: "分析概览", parentId: "01", childNode: [] }
        ]
      },
      {
        id: "02", name: "用电监控", parentId: "root", childNode: [
          { id: "021", name: "实时数据", parentId: "02", childNode: [] },
          { id: "022", name: "曲线数据", parentId: "02", childNode: [] }
        ]
      },
      {
        id: "03", name: "告警管理", parentId: "root", childNode: [
          { id: "031", name: "告警查询", parentId: "03", childNode: [] },
          { id: "032", name: "告警设置", parentId: "03", childNode: [] }
        ]
      },
      {
        id: "04", name: "能耗统计", parentId: "root", childNode: [
          { id: "041", name: "电量统计", parentId: "04", childNode: [] },
          { id: "042", name: "电费统计", parentId: "04", childNode: [] },
          { id: "043", name: "分项统计", parentId: "04", childNode: [] }
        ]
      },
      {
        id: "05", name: "能耗分析", parentId: "root", childNode: [
          { id: "051", name: "电参分析", parentId: "05", childNode: [] },
          { id: "052", name: "电参对比", parentId: "05", childNode: [] },
          { id: "053", name: "电量分析", parentId: "05", childNode: [] },
          { id: "054", name: "电量对比", parentId: "05", childNode: [] },
          { id: "055", name: "需量分析", parentId: "05", childNode: [] }
        ]
      },
      {
        id: "06", name: "报表管理", parentId: "root", childNode: [
          { id: "061", name: "电量报表", parentId: "06", childNode: [] },
          { id: "062", name: "功率报表", parentId: "06", childNode: [] },
          { id: "063", name: "电费报表", parentId: "06", childNode: [] },
          { id: "064", name: "电参报表", parentId: "06", childNode: [] }
        ]
      },
      {
        id: "07", name: "缴费管理", parentId: "root", childNode: [
          { id: "071", name: "用户管理", parentId: "07", childNode: [] },
          { id: "072", name: "充值缴费", parentId: "07", childNode: [] },
          { id: "073", name: "缴费记录", parentId: "07", childNode: [] }
        ]
      },
      {
        id: "08", name: "运维管理", parentId: "root", childNode: [
          { id: "081", name: "运维概览", parentId: "08", childNode: [] },
          { id: "082", name: "巡检计划", parentId: "08", childNode: [] },
          { id: "083", name: "维保计划", parentId: "08", childNode: [] }
        ]
      },
      {
        id: "09", name: "档案管理", parentId: "root", childNode: [
          { id: "091", name: "建筑管理", parentId: "09", childNode: [] },
          { id: "092", name: "设备管理", parentId: "09", childNode: [] }
        ]
      },
      {
        id: "10", name: "参数设置", parentId: "root", childNode: [
          { id: "101", name: "电价设置", parentId: "10", childNode: [] },
          { id: "102", name: "费控设置", parentId: "10", childNode: [] },
          { id: "103", name: "定时任务设置", parentId: "10", childNode: [] },
          { id: "104", name: "表计参数设置", parentId: "10", childNode: [] },
          { id: "105", name: "召测与设置", parentId: "10", childNode: [] },
          { id: "106", name: "能耗折算", parentId: "10", childNode: [] },
          { id: "107", name: "分项设置", parentId: "10", childNode: [] }
        ]
      },
      {
        id: "11", name: "系统设置", parentId: "root", childNode: [
          { id: "111", name: "权限管理", parentId: "11", childNode: [] }
        ]
      }
    ]
  },
  '资产管理系统': {
    premission: [
      {
        id: "001", name: "实时资产数据中心", parentId: "root", childNode: []
      },
      {
        id: "002", name: "资产管理", parentId: "root", childNode: [
          { id: "003", name: "资产入库", parentId: "002", childNode: [] },
          { id: "004", name: "资产领用", parentId: "002", childNode: [] },
          { id: "005", name: "资产退库", parentId: "002", childNode: [] },
          { id: "006", name: "资产维修", parentId: "002", childNode: [] },
          { id: "007", name: "资产报废", parentId: "002", childNode: [] }
        ]
      },
      {
        id: "008", name: "资产查询", parentId: "root", childNode: [
          { id: "009", name: "资产清单", parentId: "008", childNode: [] },
          { id: "0010", name: "到期资产", parentId: "008", childNode: [] },
          { id: "0011", name: "折旧报表", parentId: "008", childNode: [] },
          { id: "0012", name: "资产分类汇总", parentId: "008", childNode: [] },
          { id: "0013", name: "分类使用情况", parentId: "008", childNode: [] }
        ]
      },
      {
        id: "014", name: "资产设置", parentId: "root", childNode: [
          { id: "015", name: "资产分类设置", parentId: "014", childNode: [] },
          { id: "016", name: "资产存放位置设置", parentId: "014", childNode: [] },
          { id: "017", name: "资产折旧设置", parentId: "014", childNode: [] },
          { id: "018", name: "资产预警设置", parentId: "014", childNode: [] },
          { id: "019", name: "打印标签设置", parentId: "014", childNode: [] }
        ]
      },
      {
        id: "020", name: "资产盘点", parentId: "root", childNode: [
          { id: "021", name: "盘点任务", parentId: "020", childNode: [] }
        ]
      },
      {
        id: "022", name: "系统管理", parentId: "root", childNode: [
          { id: "023", name: "建筑管理", parentId: "022", childNode: [] },
          { id: "024", name: "员工管理", parentId: "022", childNode: [] },
          { id: "025", name: "角色管理", parentId: "022", childNode: [] },
          { id: "026", name: "管理员管理", parentId: "022", childNode: [] }
        ]
      }
    ]
  },
  '3d模型测试': {
    premission: [
      {
        id: "001", name: "实时资产数据中心", parentId: "root", childNode: []
      }
    ]
  }
}

export default {
  ENERGY_FILE_SERVER,
  TEST_LOGIN_DATA, TEST_SYS_MODULES,
  STATIC_PERMISSION_PROP,
  MAIN_PAGE_TYPE_LEFT, MAIN_PAGE_TYPE_TOP, MAIN_PAGE_TYPE_TOP_LEFT, MAIN_PAGE_TYPE_LEFT_RIGHT_TOP,

  INPUT_SIZE, PAGE_SIZE_8, PAGE_SIZE_10, PAGE_SIZE_12, PAGE_SIZE_18,

  PROTOCOL_MAP, SPEED_MAP, PROVINCE_ABBREVIATION, ELECTRIC_TYPE, DUTY_TYPE,

  PERMISSION_ID, PERMISSION_TITLE, PERMISSION_ICON, PERMISSION_MENU_ICONS,
  SMART_CARD_ID, SMART_CARD_TITLE, SMART_CARD_ICON, SMART_CARD_MENU_ICONS,
  ENERGY_EFFICIENCY_ID, ENERGY_EFFICIENCY_TITLE, ENERGY_EFFICIENCY_ICON, ENERGY_EFFICIENCY_ICON1, ENERGY_EFFICIENCY_MENU_ICONS,
  THEMES,
  GREEN_MENU_COLORS, BLACK_MENU_COLORS, WHITE_MENU_COLORS
}



// WEBPACK FOOTER //
// ./src/config/config_system.js